/**
 * The block tree, shared by the editor and the renderer.
 *
 * Both bodies this console edits — the editorial post and the two
 * informational pages — store a **block tree, never markup**, and both drive
 * one hook vocabulary. The two differ only in input shape: a field per block on
 * the pages, a continuous flow on the post.
 *
 * The concrete v1 block set is **not declared here and is not invented here**.
 * It is contract from the UI/UX pack (the editor's slash menu and the pages'
 * three kinds) and from `backend-content`'s stored schema, and it is registered
 * by `/implement frontend-page` on both sides at once — a new block type ships
 * the editor block **and** the renderer **and** the schema change, or the
 * contract-drift check fails.
 */

export interface BlockNode {
  /** ULID, minted client-side when the block is created. */
  id: string;
  /** Registry key. Unknown types are preserved on round-trip, never dropped. */
  type: string;
  data: Record<string, unknown>;
  children?: BlockNode[];
}

export type BlockTree = BlockNode[];

export function isBlockNode(value: unknown): value is BlockNode {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as BlockNode).id === 'string' &&
    typeof (value as BlockNode).type === 'string'
  );
}
